module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tc mb4 bg-white shadow-theme br-all br20 pv3 flex-1"
  }, [_c('h2', {
    staticClass: "mt4"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "mb4"
  }, [_c('h3', {
    staticClass: "gray"
  }, [_vm._v(_vm._s(_vm.subtitle))]), _vm._v(" "), _c('div', {
    staticClass: "mt4"
  }, [_c('div', {
    staticClass: "f5 fw4 gray",
    class: _vm.descriptionStyles
  }, [_c('strong', {
    domProps: {
      "innerHTML": _vm._s(_vm.description)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-column mv4"
  }, [_c('div', {
    staticClass: "flex justify-center"
  }, [_c('label', {
    staticClass: "b mid-gray",
    class: !_vm.isMobile ? 'f3' : 'f5'
  }, [_vm._v("$")]), _vm._v(" "), _c('label', {
    staticClass: "b mid-gray",
    class: !_vm.isMobile ? 'f1-ns' : 'f3'
  }, [_vm._v(_vm._s(_vm.price))])]), _vm._v(" "), _c('label', {
    staticClass: "mid-gray f4"
  }, [_vm._v(_vm._s(_vm.$t('planssettings.basic.range', {
    range: 'per month'
  })))])]), _vm._v(" "), (_vm.buttonPrimary) ? _c('div', {
    staticClass: "dib-ns w-90 mt3",
    class: _vm.isMobile ? 'card-margin' : ''
  }, [_c('ak-button', {
    attrs: {
      "primary": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onClick.apply(null, arguments)
      }
    }
  }, [_c('strong', [_vm._v("\n        " + _vm._s(_vm.buttonTitle) + "\n        ")])])], 1) : _c('div', {
    staticClass: "dib-ns w-90 mt3",
    class: _vm.isMobile ? 'card-margin' : ''
  }, [_c('ak-button', {
    attrs: {
      "secondary": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onClick.apply(null, arguments)
      }
    }
  }, [_c('strong', [_vm._v("\n        " + _vm._s(_vm.buttonTitle) + "\n        ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "f5 fw gray mt4"
  }, _vm._l((_vm.planData), function(info, index) {
    return _c('ak-icon-with-text', {
      key: index,
      attrs: {
        "labelClass": _vm.planData.length - 1 === index ? 'b mid-gray' : '',
        "divClass": "mv3",
        "text": info,
        "svg": "/static/appicons/Check.svg",
        "svgStyle": "margin-top: -1px"
      }
    })
  }), 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-537905c0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PlanCard.vue
// module id = 1294
// module chunks = 0